import {parseTextResult} from 'back-connector'
import {
    CreatePayLinkRequest,
    getWithAuth,
    patchWithAuth,
    PaymentLink,
    PaymentLinkRequest,
    PaymentLinkResponse,
    postWithAuth,
    SendMessageRequest,
    PaymentLinkPdfDownloadRequest
} from '@/api'

export * from './models'

export const getPaymentLinks = (request: PaymentLinkRequest) =>
    getWithAuth<PaymentLinkResponse>('/oppapi/v1/payment-links', request)

export const getPaymentLinksV2 = (request: PaymentLinkRequest) =>
    postWithAuth<PaymentLinkResponse>('/oppapi/v1/payment-links/search', request)

export const createPaymentLink = (fields: CreatePayLinkRequest) =>
    postWithAuth<PaymentLink>('/oppapi/v1/payment-links', fields)

export const editLink = (id, data) =>
    patchWithAuth<PaymentLink>(`/oppapi/v1/payment-links/${id}`, data)

export const cancelLink = (id) =>
    postWithAuth<PaymentLink>(`/oppapi/v1/payment-links/${id}/cancellation`, null)

export const sendMessage = (id, data: SendMessageRequest) =>
    postWithAuth<null>(`/oppapi/v1/payment-links/${id}/message`, data)

export const getPaymentLinkPdf = (data: PaymentLinkPdfDownloadRequest) =>
    postWithAuth(`/oppapi/v1/payment-links/pdf-qr`, data, [], {
        parseResponse: async (res) => {
            if (res.status !== 200) {
                const error = await parseTextResult(res)
                throw new Error(error.message)
            }
            const blobFile = await res.blob()
            return blobFile
        }
    })
